import { render } from "./dayone.vue?vue&type=template&id=53b38cc8"
import script from "./dayone.vue?vue&type=script&lang=js"
export * from "./dayone.vue?vue&type=script&lang=js"

import "./dayone.vue?vue&type=style&index=0&id=53b38cc8&lang=scss"
script.render = render

export default script